<div class="centered">
  <mat-icon class="icon">unknown_med</mat-icon>
  <p>Unknown Link</p>
</div>
